/* eslint-disable import/prefer-default-export */
import buildEnum from 'utils/buildEnum';

const keyFor = type => key => `customer.${type}.${key}`;

export const fieldIds = {
  national: buildEnum(['customer', 'domicile', 'terminal'], keyFor('national')),
  store: buildEnum(['customer'], keyFor('store')),
  customStore: buildEnum(['name'], keyFor('customStore')),
  other: buildEnum(['name', 'zip'], keyFor('other')),
};



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/constants.js